<button class="styleButton" mat-raised-button [ngClass]="color" disabled="{{disabled}}">
    <mat-icon><em [ngClass]="icon"></em></mat-icon>
    {{title}}
    <mat-icon><em [ngClass]="iconName"></em></mat-icon>
</button>